/* eslint-disable no-unused-vars */
import {
    Box,
    Container,
    Grid,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Switch,
    TextField,
    Card,
    CardContent,
    Checkbox,
    Divider,
    Chip,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import styles from "./Styles.module.scss";
import { DataContext } from "../../App";
import logo from "../../images/apimasters-logo.svg";
// import { validateForgotPassword, validateSignIn } from "../Handle";
import axios from "../../axios";
import Auth from "../../Auth";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/lib/css/styles.css";

import MiniLoading from "../../components/MiniLoading";
import * as helper from "../../helper";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTranslation } from "react-i18next";
import usePermissionGuard from "../../hooks/usePermissionGuard";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`,
    };
}

export default function Settings() {
    return <WebsiteSettings />;
}

export function WebsiteSettings() {
    // ── all hooks first ──────────────────────────────────────────────────────
    usePermissionGuard("manage_settings");
    const [loading, setLoading] = React.useState(true);
    const [value, setValue] = React.useState(() => {
        const saved = localStorage.getItem('settings_inner_tab');
        return saved !== null ? parseInt(saved, 10) : 0;
    });
    const [primaryColor, setPrimaryColor] = useColor("hex", (window.storeSettings.primary_color == null ||
        window.storeSettings.primary_color ===
        "default") ? "#121212" : window.storeSettings.primary_color);
    const [secondaryColor, setSecondaryColor] = useColor("hex", (window.storeSettings.secondary_color == null ||
        window.storeSettings.secondary_color ===
        "default") ? "#121212" : window.storeSettings.secondary_color);
    const { setSnackbar } = useContext(DataContext);
    const [saveButtonDisabled, setSaveButtonDisabled] = React.useState(false);
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState(window.storeSettings || {
        site_name: "",
        site_description: "",
        address_section: "",
        top_logo: null,
        language: "en",
        store_support_email: window.user.email,
    });
    const [warehouses, setWarehouses] = useState([]);
    const [layouts, setLayouts] = useState([]);
    const [extraFields, setExtraFields] = useState([]);
    const [selectionCodes, setSelectionCodes] = useState([]);

    useEffect(() => {
            if (Auth.getUser().store_division == null) {
                setLoading(false);
            } else {
                axios
                    .get("/exact/store/details/" + Auth.getUser().store_division)
                    .then((response) => {
                        setInputValue(response.data.data);
                        setPrimaryColor({
                            "hex": response.data.data.primary_color,
                            rgb: helper.hexToRGB(response.data.data.primary_color),
                            hsv: helper.hexToHSL(response.data.data.primary_color)
                        });

                        setSecondaryColor({
                            "hex": response.data.data.secondary_color,
                            rgb: helper.hexToRGB(response.data.data.secondary_color),
                            hsv: helper.hexToHSL(response.data.data.secondary_color)
                        });

                        setLoading(false);
                    }).catch(() => {
                        setLoading(false);
                    });
            }
        }, []);

    useEffect(() => {
        axios.get('/exact/store/warehouses').then((res) => {
            setWarehouses(res.data.data ?? []);
        }).catch(() => {});

        axios.get('/exact/store/layouts').then((res) => {
            setLayouts(res.data.data ?? []);
        }).catch(() => {});

        axios.get('/exact/store/extra-fields').then((res) => {
            setExtraFields(res.data.data ?? []);
        }).catch(() => {});

        axios.get('/exact/store/selection-codes').then((res) => {
            setSelectionCodes(res.data.data ?? []);
        }).catch(() => {});
    }, []);

    const [storeSummary, setStoreSummary] = React.useState(null);
    useEffect(() => {
        axios.get('/admin/store/dashboard/summary').then(r => setStoreSummary(r.data.data)).catch(() => {});
    }, []);

    // ── handlers & helpers ────────────────────────────────────────────────────

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        localStorage.setItem('settings_inner_tab', newValue);
    };

    // warehouse_filter is a whitelist of Warehouse UUIDs; null = all included
    const warehouseFilter = inputValue.warehouse_filter ?? null;

    const isWarehouseIncluded = (warehouseId) => {
        if (warehouseFilter === null) return true;
        return Array.isArray(warehouseFilter) && warehouseFilter.includes(warehouseId);
    };

    const toggleWarehouse = (warehouseId) => {
        // If currently null (all included), switching one off means we build a whitelist of all except this one
        const currentList = warehouseFilter === null
            ? warehouses.map((w) => w.Warehouse)
            : [...warehouseFilter];

        const next = currentList.includes(warehouseId)
            ? currentList.filter((id) => id !== warehouseId)
            : [...currentList, warehouseId];

        // If all warehouses are checked, store null (= all included, no filter)
        const allChecked = warehouses.length > 0 && next.length === warehouses.length;

        setInputValue((prev) => ({
            ...prev,
            warehouse_filter: allChecked ? null : next,
        }));
    };

    // notification_settings shape: { "<topic>": ["a@b.com", ...] } — the field edits a
    // comma-separated string; the backend normalises to a clean array on save.
    // Unset topic = pre-filled with the admin login email (also the server fallback).
    const getNotifEmails = (topic) => {
        const v = inputValue.notification_settings?.[topic];
        if (v == null) return Auth.getUser()?.email ?? "";
        return Array.isArray(v) ? v.join(", ") : v;
    };

    const setNotifEmails = (topic, value) => {
        setInputValue((prev) => ({
            ...prev,
            notification_settings: { ...(prev.notification_settings || {}), [topic]: value },
        }));
    };

    // extra_field_settings shape: { "<number>": { detail: bool, grid: bool } }
    const getExtraField = (num, flag) => !!(inputValue.extra_field_settings?.[num]?.[flag]);

    const toggleExtraField = (num, flag) => {
        setInputValue((prev) => {
            const current = prev.extra_field_settings || {};
            const row = { detail: false, grid: false, ...(current[num] || {}) };
            row[flag] = !row[flag];
            return { ...prev, extra_field_settings: { ...current, [num]: row } };
        });
    };

    const handleChange = (event) => {
        setInputValue((prevState) => ({
            ...prevState,
            [event.target.id ?? event.target.name]:
                event.target.type === "checkbox"
                    ? event.target.checked
                    : event.target.value,
        }));
    };

    const saveThemeSettings = () => {
        setSaveButtonDisabled(true);
        axios
            .post("/exact/store/settings", {
                primary_color: primaryColor.hex,
                secondary_color: secondaryColor.hex,
            })
            .then((response) => {
                setSnackbar({
                    message:
                        t("Theme settings saved successfully."),
                    severity: "success",
                    open: true,
                });

                localStorage.removeItem('currentStoreTheme');
                window.location.reload();
            })
            .catch(({ response }) => {
                console.log(response);
                setSnackbar({
                    message:
                        t(response.data?.message ||
                            "An error occured while saving store settings."),
                    severity: "error",
                    open: true,
                });
            }).finally(() => {
                setSaveButtonDisabled(false);
            });
    };

    const saveSettings = () => {
        setSaveButtonDisabled(true);
        axios
            .post("/exact/store/settings", inputValue)
            .then((response) => {
                setSnackbar({
                    message:
                        t("Site settings saved successfully."),
                    severity: "success",
                    open: true,
                });

                localStorage.removeItem('currentStoreTheme');
                window.location.reload();
            })
            .catch(({ response }) => {
                console.log(response);

                setSnackbar({
                    message:
                        t(response.data?.message ||
                            "An error occured while saving store settings."),
                    severity: "error",
                    open: true,
                });
            }).finally(() => {
                setSaveButtonDisabled(false);
            });
    };

    const handleCapture = ({ target }) => {
        const fileReader = new FileReader();
        const name = target.id;

        fileReader.readAsDataURL(target.files[0]);
        fileReader.onload = (e) => {
            setInputValue((prevState) => ({
                ...prevState,
                [name]: e.target.result,
            }));
        };
    };

    return (
        <Container sx={{ marginTop: 4, marginBottom: 4 }}>
            <h2>{t("Settings")}</h2>

            {/* ── Status banners ─────────────────────────────────────────── */}
            {storeSummary && (
                <Box sx={{ mb: 2, display: "flex", flexDirection: "column", gap: 1 }}>
                    {!storeSummary.eo_connected && (
                        <Box sx={{ p: "10px 16px", borderRadius: 2, border: "1px solid #ef9a9a", background: "#ffebee", fontSize: 13, color: "#c62828", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span>⚠️ {t("exact_connection_has_been_lost")}</span>
                            <Chip label={t("Re-authorize")} size="small" onClick={() => window.location.href = '/exact/auth'} sx={{ cursor: "pointer", background: "#c62828", color: "#fff", fontSize: 11 }} />
                        </Box>
                    )}
                    {storeSummary.eo_connected && (
                        <Box sx={{ p: "10px 16px", borderRadius: 2, border: "1px solid #a5d6a7", background: "#e8f5e9", fontSize: 13, color: "#2e7d32", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span>✅ {t("you_are_connected")}</span>
                            <Chip label={t("connected")} size="small" sx={{ background: "#2e7d32", color: "#fff", fontSize: 11 }} />
                        </Box>
                    )}
                    {storeSummary.subscription && !storeSummary.subscription.active && (
                        <Box sx={{ p: "10px 16px", borderRadius: 2, border: "1px solid #ef9a9a", background: "#ffebee", fontSize: 13, color: "#c62828" }}>
                            ⚠️ {t("subscription_is_not_active")}
                        </Box>
                    )}
                    {storeSummary.subscription?.active && storeSummary.subscription.days_left <= 14 && (
                        <Box sx={{ p: "10px 16px", borderRadius: 2, border: "1px solid #ffe082", background: "#fff8e1", fontSize: 13, color: "#e65100" }}>
                            ⚠️ {t("subscription_left").replace(":days", storeSummary.subscription.days_left)}
                            {storeSummary.subscription.end_date && ` — ${new Date(storeSummary.subscription.end_date).toLocaleDateString("nl-NL")}`}
                        </Box>
                    )}
                </Box>
            )}

            <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value} onChange={handleChangeTab}
                        sx={{
                            borderRight: 1, borderColor: "divider",
                            ".Mui-selected": {
                                color: "var(--primary)"
                            },
                        }}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "var(--primary)",
                            }
                        }}
                    >
                        <Tab label={t("Theme settings")} {...a11yProps(0)} />
                        <Tab label={t("Shop settings")} {...a11yProps(1)} />
                        <Tab label={t("Order settings")} {...a11yProps(2)} />
                        <Tab label={t("Stock settings")} {...a11yProps(3)} />
                        <Tab label={t("Product fields")} {...a11yProps(4)} />
                        <Tab label={t("Notifications")} {...a11yProps(5)} />
                    </Tabs>
                </Box>
                {loading ? <Box sx={{ marginTop: 4 }}>
                    <MiniLoading />
                </Box> :
                    Auth.getUser().store_division == null ?
                        <Box sx={{ marginTop: 4 }}>
                            <span >{t("Please complete Exactnline authentication first")}</span>
                        </Box>
                        :
                        <>
                            <CustomTabPanel value={value} index={0}>
                                <Box>
                                    <h3>{t("Background main color")}</h3>
                                    <ColorPicker
                                        width={456}
                                        height={228}
                                        color={primaryColor}
                                        onChange={setPrimaryColor}
                                        hideHSV
                                    />
                                </Box>
                                {/* <Box>
                                    <h3>Foreground color</h3>
                                    <ColorPicker
                                        width={456}
                                        height={228}
                                        color={secondaryColor}
                                        onChange={setSecondaryColor}
                                        hideHSV
                                    />
                                </Box> */}
                                <Button
                                    variant="contained"
                                    sx={{ marginTop: 3 }}
                                    size="small"
                                    color="apimasters"
                                    onClick={saveThemeSettings}
                                    disabled={saveButtonDisabled}
                                >
                                    {t("Save")}
                                </Button>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                                <Container>
                                    <Grid
                                        container
                                        spacing={3}
                                        justifyContent="center"
                                        alignItems="stretch"
                                    >
                                        <Grid item xs={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md">
                                                        {t("Shop Name")} *
                                                    </Typography>
                                                    <FormControl
                                                        sx={{ width: "100%", marginTop: 1 }}
                                                    >
                                                        <TextField
                                                            id="site_name"
                                                            // label="Title"
                                                            name="site_name"
                                                            onChange={handleChange}
                                                            value={inputValue.site_name}
                                                        />
                                                    </FormControl>
                                                </CardContent>
                                            </Card>
                                        </Grid><Grid item xs={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md">
                                                        {t("Shop Domain (shop.example.com)")}
                                                    </Typography>
                                                    <FormControl
                                                        sx={{ width: "100%", marginTop: 1 }}
                                                    >
                                                        <TextField
                                                            id="subdomain"
                                                            // label="Title"
                                                            name="subdomain"
                                                            onChange={handleChange}
                                                            value={inputValue.subdomain}
                                                        />
                                                    </FormControl>
                                                    <Typography level="title-sm" sx={{ marginTop: 2, marginBottom: 0 }}>
                                                        <b>{t("Status")}:</b> {inputValue.domain_status === "not sent for approval"
                                                            ? <span >{t("Please type shop domain and save")}</span> :
                                                            inputValue.domain_status === "approved"
                                                                ?
                                                                <span style={{ color: "green" }}>{t("Approved")} (<a target="_blank" rel="noreferrer"
                                                                    href={"http://" + inputValue.subdomain}>{inputValue.subdomain} <OpenInNewIcon style={{ verticalAlign: "middle" }} fontSize="1rem" /></a>)</span> :
                                                                <span style={{ color: "orange" }}>{t("Pending")}</span>

                                                        }
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md">
                                                        {t("Shop Description")}
                                                    </Typography>
                                                    <FormControl
                                                        sx={{ width: "100%", marginTop: 1 }}
                                                    >
                                                        <TextField
                                                            id="site_description"
                                                            // label="Site Description"
                                                            name="site_description"
                                                            multiline
                                                            rows={4}
                                                            onChange={handleChange}
                                                            value={inputValue.site_description}
                                                        />
                                                    </FormControl>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md">
                                                        {t("Address Section")}
                                                    </Typography>
                                                    <FormControl
                                                        sx={{ width: "100%", marginTop: 1 }}
                                                    >
                                                        <TextField
                                                            id="address_section"
                                                            // label="Address Section"
                                                            multiline
                                                            rows={4}
                                                            name="address_section"
                                                            onChange={handleChange}
                                                            value={inputValue.address_section}
                                                        />
                                                    </FormControl>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md">
                                                        {t("Header Logo (Advice for size 450x110px.)")}
                                                    </Typography>
                                                    <Button
                                                        variant="contained"
                                                        sx={{ marginTop: 1 }}
                                                        size="small"
                                                        component="label"
                                                        color="apimasters"
                                                    >
                                                        {t("Upload Logo")}
                                                        <input
                                                            type="file"
                                                            hidden
                                                            accept="image/*"
                                                            onChange={handleCapture}
                                                            id="top_logo"
                                                        />
                                                    </Button>
                                                    <img
                                                        alt="top logo"
                                                        src={
                                                            inputValue.top_logo ?? logo}
                                                        style={{ marginTop: 20, width: "100%" }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md">
                                                        {t("Footer Logo (Advice for size 225x55px.)")}
                                                    </Typography>
                                                    <Button
                                                        variant="contained"
                                                        sx={{ marginTop: 1 }}
                                                        size="small"
                                                        component="label"
                                                        id="footer_logo"
                                                        color="apimasters"
                                                    >
                                                        {t("Upload Logo")}
                                                        <input type="file"
                                                            hidden
                                                            accept="image/*"
                                                            id="footer_logo"
                                                            onChange={handleCapture} />
                                                    </Button>
                                                    <img
                                                        alt="footer logo"
                                                        src={inputValue.footer_logo ?? logo}
                                                        style={{ marginTop: 20, width: "100%" }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md">
                                                        {t("Store Language")}
                                                    </Typography>
                                                    <FormControl>
                                                        <Select
                                                            value={inputValue.language ?? 'en'}
                                                            label={""}
                                                            id="language"
                                                            name="language"
                                                            color={"primary"}
                                                            sx={{ marginTop: 2 }}
                                                            size="small"
                                                            onChange={handleChange}>
                                                            <MenuItem value={'en'}>English</MenuItem>
                                                            <MenuItem value={'nl'}>Dutch</MenuItem>
                                                            <MenuItem value={'de'}>Deutsch</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md">
                                                        {t("Shop Support Email")} *
                                                    </Typography>
                                                    <FormControl
                                                        sx={{ width: "100%", marginTop: 1 }}
                                                    >
                                                        <TextField
                                                            id="store_support_email"
                                                            // label="Title"
                                                            name="store_support_email"
                                                            onChange={handleChange}
                                                            value={inputValue.store_support_email}
                                                        />
                                                    </FormControl>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md" sx={{ marginBottom: 2 }}>
                                                      {t("Webhook Configuration")}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ marginBottom: 2, color: 'text.secondary' }}>
                                                      {t("Configure webhooks to receive real-time order notifications")}
                                                    </Typography>

                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                id="webhook_on_order"
                                                                name="webhook_on_order"
                                                                checked={inputValue.webhook_on_order ?? false}
                                                                onChange={handleChange}
                                                            />
                                                        }
                                                        label="Enable order webhooks"
                                                    />

                                                    {inputValue.webhook_on_order && (
                                                        <>
                                                            <Typography level="title-md" sx={{ marginTop: 2 }}>
                                                                Webhook URL
                                                            </Typography>
                                                            <FormControl sx={{ width: "100%", marginTop: 1 }}>
                                                                <TextField
                                                                    id="webhook_url"
                                                                    name="webhook_url"
                                                                    placeholder="https://example.com/webhook/orders"
                                                                    onChange={handleChange}
                                                                    value={inputValue.webhook_url ?? ''}
                                                                    helperText="Enter the URL where order notifications should be sent"
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Container>

                                <Button
                                    variant="contained"
                                    sx={{ marginTop: 3, marginLeft: 3 }}
                                    size="small"
                                    onClick={saveSettings}
                                    disabled={saveButtonDisabled}
                                    color="apimasters"
                                >
                                    {t("Save")}
                                </Button>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={2}>
                                <Container>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md" sx={{ marginBottom: 2 }}>
                                                        {t("Order Fields Configuration")}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ marginBottom: 2, color: 'text.secondary' }}>
                                                        {t("Allow customers to add reference notes and delivery dates during checkout")}
                                                    </Typography>

                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                id="allow_reference_field"
                                                                name="allow_reference_field"
                                                                checked={inputValue.allow_reference_field ?? false}
                                                                onChange={handleChange}
                                                            />
                                                        }
                                                        label={t("Allow reference/remarks field (max 200 characters)")}
                                                    />

                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                id="allow_delivery_date_field"
                                                                name="allow_delivery_date_field"
                                                                checked={inputValue.allow_delivery_date_field ?? false}
                                                                onChange={handleChange}
                                                            />
                                                        }
                                                        label={t("Allow delivery date selection (weekdays only)")}
                                                        sx={{ display: 'block', marginTop: 1 }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md" sx={{ marginBottom: 1 }}>
                                                        {t("Order mode")}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                                                        {t("Controls whether a quotation is automatically converted to a sales order after checkout.")}
                                                    </Typography>
                                                    <FormControl sx={{ width: "100%", marginBottom: 3 }} variant="standard">
                                                        <InputLabel id="order-mode-label">{t("Mode")}</InputLabel>
                                                        <Select
                                                            labelId="order-mode-label"
                                                            id="order_mode"
                                                            name="order_mode"
                                                            value={inputValue.order_mode ?? "quotation_to_order"}
                                                            onChange={handleChange}
                                                            label={t("Mode")}
                                                        >
                                                            <MenuItem value="quotation_to_order">{t("Quotation → Sales Order")}</MenuItem>
                                                            <MenuItem value="quotation_only">{t("Quotation only")}</MenuItem>
                                                        </Select>
                                                    </FormControl>

                                                    {(inputValue.order_mode ?? "quotation_to_order") === "quotation_to_order" && (
                                                        <>
                                                            <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 1 }}>
                                                                {t("Enable this if 'Approve quotations' is turned on in ExactOnline. AcceptQuotation will be skipped and the quotation stays pending approval.")}
                                                            </Typography>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        id="quotation_requires_approval"
                                                                        name="quotation_requires_approval"
                                                                        checked={inputValue.quotation_requires_approval ?? false}
                                                                        onChange={handleChange}
                                                                    />
                                                                }
                                                                label={t("Quotation requires approval")}
                                                            />
                                                        </>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md" sx={{ marginBottom: 1 }}>
                                                        {t("Sales order selection code")}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                                                        {t("Stamp this ExactOnline selection code on every order the portal creates (e.g. B2B). Choose “none” for no code.")}
                                                    </Typography>
                                                    <FormControl variant="standard" sx={{ width: "100%" }}>
                                                        <InputLabel id="selcode-label">{t("Selection code")}</InputLabel>
                                                        <Select
                                                            labelId="selcode-label"
                                                            value={inputValue.order_selection_code ?? ""}
                                                            onChange={(e) => {
                                                                const sel = selectionCodes.find((c) => c.id === e.target.value);
                                                                setInputValue((prev) => ({
                                                                    ...prev,
                                                                    order_selection_code: e.target.value,
                                                                    order_selection_code_label: sel ? sel.code : "",
                                                                }));
                                                            }}
                                                            label={t("Selection code")}
                                                        >
                                                            <MenuItem value=""><em>{t("— none —")}</em></MenuItem>
                                                            {selectionCodes.map((c) => (
                                                                <MenuItem key={c.id} value={c.id}>
                                                                    {c.code}{c.description && c.description !== c.code ? ` — ${c.description}` : ""}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                    {inputValue.order_selection_code && selectionCodes.length === 0 && (
                                                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", marginTop: 1 }}>
                                                            {t("Currently set")}: {inputValue.order_selection_code_label || inputValue.order_selection_code}
                                                        </Typography>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Container>
                                <Button
                                    variant="contained"
                                    sx={{ marginTop: 3, marginLeft: 3 }}
                                    size="small"
                                    onClick={saveSettings}
                                    disabled={saveButtonDisabled}
                                    color="apimasters"
                                >
                                    {t("Save")}
                                </Button>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={3}>
                                <Container>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={8}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md" sx={{ marginBottom: 2 }}>
                                                        {t("Stock visibility")}
                                                    </Typography>

                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                id="show_stock_numbers"
                                                                name="show_stock_numbers"
                                                                checked={inputValue.show_stock_numbers ?? false}
                                                                onChange={handleChange}
                                                            />
                                                        }
                                                        label={t("Show stock numbers to customers")}
                                                    />

                                                    {(inputValue.show_stock_numbers ?? false) && (<>
                                                        <Divider sx={{ my: 2 }} />

                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    id="show_warehouse_breakdown"
                                                                    name="show_warehouse_breakdown"
                                                                    checked={inputValue.show_warehouse_breakdown ?? false}
                                                                    onChange={handleChange}
                                                                />
                                                            }
                                                            label={t("Show per-warehouse breakdown on product page (admin & impersonated sessions only)")}
                                                        />

                                                        {warehouses.length > 0 && (<>
                                                            <Divider sx={{ my: 2 }} />
                                                            <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                                                {t("Warehouse stock inclusion")}
                                                            </Typography>
                                                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                                {t("Checked warehouses are included in the customer-visible stock total. Unchecked warehouses are excluded from the sum but still visible to admin/impersonated sessions in the breakdown.")}
                                                            </Typography>
                                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                                {warehouses.map((wh) => {
                                                                    const included = isWarehouseIncluded(wh.Warehouse);
                                                                    return (
                                                                        <Box
                                                                            key={wh.Warehouse}
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'space-between',
                                                                                px: 1.5,
                                                                                py: 0.75,
                                                                                border: '1px solid',
                                                                                borderColor: included ? 'success.light' : 'divider',
                                                                                borderRadius: 1,
                                                                                bgcolor: included ? 'success.50' : 'grey.50',
                                                                            }}
                                                                        >
                                                                            <FormControlLabel
                                                                                sx={{ m: 0, flexGrow: 1 }}
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={included}
                                                                                        onChange={() => toggleWarehouse(wh.Warehouse)}
                                                                                        size="small"
                                                                                        color="success"
                                                                                    />
                                                                                }
                                                                                label={
                                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                                                            {wh.WarehouseCode}
                                                                                        </Typography>
                                                                                        <Typography variant="body2" color="text.secondary">
                                                                                            {wh.WarehouseDescription}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                }
                                                                            />
                                                                            <Chip
                                                                                label={included ? t("Included in sum") : t("Excluded from sum")}
                                                                                size="small"
                                                                                color={included ? "success" : "default"}
                                                                                variant={included ? "filled" : "outlined"}
                                                                                sx={{ fontSize: 11 }}
                                                                            />
                                                                        </Box>
                                                                    );
                                                                })}
                                                            </Box>
                                                        </>)}
                                                    </>)}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md" sx={{ marginBottom: 1 }}>
                                                        {t("Order Confirmation Email")}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                                                        {t("Select at least one ExactOnline layout to enable automatic order confirmation emails. Per-account defaults are managed in the Accounts page.")}
                                                    </Typography>

                                                    {layouts.length === 0 ? (
                                                        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                                            {t("No SalesOrder layouts found. Make sure ExactOnline is authenticated.")}
                                                        </Typography>
                                                    ) : (<>
                                                        <FormControl variant="standard" sx={{ width: '100%', marginBottom: 3 }}>
                                                            <InputLabel id="doc-layout-label">{t("Document layout (PDF)")}</InputLabel>
                                                            <Select
                                                                labelId="doc-layout-label"
                                                                id="order_confirmation_document_layout"
                                                                name="order_confirmation_document_layout"
                                                                value={inputValue.order_confirmation_document_layout ?? ''}
                                                                onChange={handleChange}
                                                                label={t("Document layout (PDF)")}
                                                            >
                                                                <MenuItem value=""><em>{t("— not selected —")}</em></MenuItem>
                                                                {layouts.filter(l => l.Type === 1).map(l => (
                                                                    <MenuItem key={l.ID} value={l.ID} disabled={!l.active}>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <span>{l.Subject}</span>
                                                                            {!l.active && <Chip label={t("Inactive")} size="small" variant="outlined" sx={{ fontSize: 10, height: 18 }} />}
                                                                        </Box>
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>

                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <InputLabel id="email-layout-label">{t("Email text layout")}</InputLabel>
                                                            <Select
                                                                labelId="email-layout-label"
                                                                id="order_confirmation_email_layout"
                                                                name="order_confirmation_email_layout"
                                                                value={inputValue.order_confirmation_email_layout ?? ''}
                                                                onChange={handleChange}
                                                                label={t("Email text layout")}
                                                            >
                                                                <MenuItem value=""><em>{t("— not selected —")}</em></MenuItem>
                                                                {layouts.filter(l => l.Type === 2).map(l => (
                                                                    <MenuItem key={l.ID} value={l.ID} disabled={!l.active}>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <span>{l.Subject}</span>
                                                                            {!l.active && <Chip label={t("Inactive")} size="small" variant="outlined" sx={{ fontSize: 10, height: 18 }} />}
                                                                        </Box>
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </>)}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Container>
                                <Button
                                    variant="contained"
                                    sx={{ marginTop: 3, marginLeft: 3 }}
                                    size="small"
                                    onClick={saveSettings}
                                    disabled={saveButtonDisabled}
                                    color="apimasters"
                                >
                                    {t("Save")}
                                </Button>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={4}>
                                <Container>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={10}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md" sx={{ marginBottom: 1 }}>
                                                        {t("Product extra fields")}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                                                        {t("Choose which ExactOnline item extra fields are shown on the product page and/or the product grid. Fields stay hidden until enabled.")}
                                                    </Typography>

                                                    {extraFields.length === 0 ? (
                                                        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                                            {t("No item extra fields have been synced yet.")}
                                                        </Typography>
                                                    ) : (
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', fontWeight: 600, fontSize: 13, color: 'text.secondary', px: 1 }}>
                                                                <Box sx={{ flexGrow: 1 }}>{t("Field")}</Box>
                                                                <Box sx={{ width: 110, textAlign: 'center' }}>{t("Product page")}</Box>
                                                                <Box sx={{ width: 70, textAlign: 'center' }}>{t("Grid")}</Box>
                                                                <Box sx={{ width: 70, textAlign: 'center' }}>{t("Cart")}</Box>
                                                                <Box sx={{ width: 100, textAlign: 'center' }}>{t("Highlight")}</Box>
                                                            </Box>
                                                            {extraFields.map((f) => (
                                                                <Box
                                                                    key={f.Number}
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        px: 1.5,
                                                                        py: 0.5,
                                                                        border: '1px solid',
                                                                        borderColor: 'divider',
                                                                        borderRadius: 1,
                                                                    }}
                                                                >
                                                                    <Box sx={{ flexGrow: 1 }}>
                                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                                            {f.Description || `Field #${f.Number}`}
                                                                        </Typography>
                                                                        <Typography variant="caption" color="text.secondary">
                                                                            #{f.Number}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ width: 110, textAlign: 'center' }}>
                                                                        <Switch
                                                                            checked={getExtraField(f.Number, 'detail')}
                                                                            onChange={() => toggleExtraField(f.Number, 'detail')}
                                                                        />
                                                                    </Box>
                                                                    <Box sx={{ width: 70, textAlign: 'center' }}>
                                                                        <Switch
                                                                            checked={getExtraField(f.Number, 'grid')}
                                                                            onChange={() => toggleExtraField(f.Number, 'grid')}
                                                                        />
                                                                    </Box>
                                                                    <Box sx={{ width: 70, textAlign: 'center' }}>
                                                                        <Switch
                                                                            checked={getExtraField(f.Number, 'cart')}
                                                                            onChange={() => toggleExtraField(f.Number, 'cart')}
                                                                        />
                                                                    </Box>
                                                                    <Box sx={{ width: 100, textAlign: 'center' }}>
                                                                        <Switch
                                                                            color="warning"
                                                                            checked={getExtraField(f.Number, 'highlight')}
                                                                            onChange={() => toggleExtraField(f.Number, 'highlight')}
                                                                        />
                                                                    </Box>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Container>
                                <Button
                                    variant="contained"
                                    sx={{ marginTop: 3, marginLeft: 3 }}
                                    size="small"
                                    onClick={saveSettings}
                                    disabled={saveButtonDisabled}
                                    color="apimasters"
                                >
                                    {t("Save")}
                                </Button>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={5}>
                                <Container>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={10}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography level="title-md" sx={{ marginBottom: 1 }}>
                                                        {t("Email notifications")}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 3 }}>
                                                        {t("Choose who receives each type of alert from the portal. Separate multiple addresses with commas. If left empty, alerts go to the shop owner's login email.")}
                                                    </Typography>

                                                    {[
                                                        {
                                                            topic: "connection_lost",
                                                            label: t("ExactOnline connection lost"),
                                                            desc: t("Action required — the shop must be reconnected to ExactOnline. Sync and new orders are paused until then."),
                                                        },
                                                        {
                                                            topic: "failed_order",
                                                            label: t("Order could not be created"),
                                                            desc: t("A customer's order failed to reach ExactOnline. It is retried automatically, but needs attention."),
                                                        },
                                                        {
                                                            topic: "endpoint_permission",
                                                            label: t("Permission issues"),
                                                            desc: t("A synchronisation was disabled because ExactOnline denied access to an endpoint."),
                                                        },
                                                    ].map((row) => (
                                                        <Box key={row.topic} sx={{ mb: 3, pb: 2.5, borderBottom: "1px solid #f0f0f0", "&:last-of-type": { borderBottom: "none", mb: 0, pb: 0 } }}>
                                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{row.label}</Typography>
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>{row.desc}</Typography>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                value={getNotifEmails(row.topic)}
                                                                onChange={(e) => setNotifEmails(row.topic, e.target.value)}
                                                                placeholder="email@company.com, second@company.com"
                                                            />
                                                        </Box>
                                                    ))}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Container>
                                <Button
                                    variant="contained"
                                    sx={{ marginTop: 3, marginLeft: 3 }}
                                    size="small"
                                    onClick={saveSettings}
                                    disabled={saveButtonDisabled}
                                    color="apimasters"
                                >
                                    {t("Save")}
                                </Button>
                            </CustomTabPanel></>}
            </Box>
        </Container>
    );
}
